<template>
    <be-card table title="Zusammenfassung">
        <table class="table table-sm table-striped">
            <tbody>
            <tr>
                <td>Eindeutige Kennung</td>
                <td>{{ assessment.id }}</td>
            </tr>
            <tr>
                <td>Erstellt</td>
                <td>{{ assessment.readableCreatedAt }}</td>
            </tr>
            </tbody>
        </table>
    </be-card>
</template>

<script>
    import Assessment from '../../../../models/Assessment';

    export default {
        props: {
            assessment: Assessment,
        },
    };
</script>
